export default __webpack_public_path__ + "static/media/heart.6e2dd6cc.svg";